/**
 * Chuỗi của tab Cấu hình thông báo và Tài khoản gửi (`/rpa/alert-config?tab=notifications|senders`). Câu chữ lấy từ
 * namespace `rpa.notifications`, `rpa.senders` của web-portal native, đổi sang kiểu dấu thanh mới. Tạm tách tệp, sẽ
 * gộp vào `vi.ts`.
 */
export const viRpaThongBao = {
  rpaThongBao: {
    phamVi: 'Áp dụng cho',
    phamViMacDinh: 'Mặc định (tất cả Project)',
    them: 'Thêm cấu hình',
    tim: 'Tìm tên cấu hình hoặc mã...',
    locSuKien: 'Lọc theo sự kiện',
    moiSuKien: 'Mọi sự kiện',
    locKenh: 'Lọc theo kênh gửi',
    moiKenh: 'Mọi kênh',
    locTrangThai: 'Lọc theo trạng thái',
    moiTrangThai: 'Mọi trạng thái',
    dem: '{{hien}} / {{tong}} cấu hình',
    tongTrang: '{{tu}}–{{den}} / {{tong}} cấu hình',
    goiYMacDinh:
      'Đang xem mọi cấu hình thông báo. Cấu hình “Tất cả dự án” áp dụng cho mọi Project, cấu hình gắn Project chỉ áp dụng cho Project đó.',
    goiYProject:
      'Thông báo áp dụng cho {{project}}: cấu hình riêng của Project, cùng cấu hình chung kế thừa. Tắt công tắc ở dòng kế thừa để Project này không nhận tin theo cấu hình đó.',
    rong: 'Chưa có cấu hình thông báo nào',
    rongProject: 'Project này chưa có cấu hình thông báo nào',
    rongMoTa: 'Thêm một cấu hình để nhận tin khi luồng chạy lỗi hoặc có kết quả.',
    rongLoc: 'Không có cấu hình nào khớp bộ lọc',
    cotTen: 'Tên cấu hình',
    cotSuKien: 'Sự kiện',
    cotPhamVi: 'Phạm vi',
    cotKenh: 'Kênh gửi',
    cotBat: 'Bật',
    tatCaDuAn: 'Tất cả dự án',
    riengProject: 'Riêng Project',
    keThua: 'Kế thừa (tất cả dự án)',
    moiWorkflow: 'Mọi Workflow',
    workflowMot: 'Chỉ Workflow {{ten}}',
    workflowNhieu: '{{so}} Workflow: {{ten}}, …',
    chuaCoBoGui: 'Sự kiện này chưa có bộ gửi tự động',
    kenhCu: '{{kenh}} (kênh cũ, không gửi)',
    keThuaDangTat: 'Đang tắt ở cấu hình chung',
    suaOMacDinh: 'Sửa ở chế độ Mặc định',
    batCauHinh: 'Bật cấu hình {{ten}}',
    daBat: 'Đã bật cấu hình thông báo.',
    daTat: 'Đã tắt cấu hình thông báo.',
    projectDaBat: 'Project này đã nhận thông báo theo cấu hình chung.',
    projectDaTat: 'Project này sẽ không nhận thông báo theo cấu hình chung.',
    kenhLoi: 'Chưa lấy được trạng thái cấu hình các kênh gửi: {{loi}}',
    sua: 'Sửa cấu hình',
    xoa: 'Xoá cấu hình',
    xoaTieuDe: 'Xoá cấu hình thông báo “{{ten}}”?',
    xoaThan: 'Cấu hình này sẽ không gửi tin nữa. Thao tác không hoàn tác được.',
    daXoa: 'Đã xoá cấu hình thông báo.',
    suKien: {
      run_failed: 'Luồng chạy thất bại',
      run_success: 'Luồng chạy thành công',
      all: 'Tất cả sự kiện',
      severity_critical: 'Lỗi mức Nghiêm trọng',
      severity_high: 'Lỗi mức Cao',
      severity_medium: 'Lỗi mức Trung bình',
      severity_low: 'Lỗi mức Thấp',
      group_infra: 'Lỗi nhóm Hạ tầng',
      robot_offline: 'Robot offline',
    },
    kenhDich: {
      telegram: 'Chat ID Telegram',
      email: 'Email người nhận',
      zalo: 'ID Zalo của người nhận',
      whatsapp: 'Số điện thoại WhatsApp',
    },
    kenhMau: {
      telegram: '-1001234567890',
      email: 'ops@congty.vn, quanly@congty.vn',
      zalo: 'Nhập ID Zalo',
      whatsapp: '+84901234567',
    },
    saiDinhDang: {
      telegram: 'Chat ID là số (nhóm bắt đầu bằng dấu -) hoặc @tên_kênh.',
      email: 'Email không hợp lệ (tối đa 20 địa chỉ, cách nhau bằng dấu phẩy).',
      zalo: 'ID Zalo chỉ gồm chữ số.',
      whatsapp: 'Số điện thoại phải có mã quốc gia, ví dụ +84901234567.',
    },
    khongCoTaiKhoan: {
      telegram: 'Chưa có tài khoản Telegram Bot đang bật — thêm ở tab Tài khoản gửi thì mới gửi qua Telegram được.',
      gmail: 'Chưa có tài khoản Gmail SMTP đang bật — thêm ở tab Tài khoản gửi thì mới gửi email được.',
    },
    form: {
      taoTieuDe: 'Thêm cấu hình thông báo',
      suaTieuDe: 'Sửa cấu hình “{{ten}}”',
      ten: 'Tên cấu hình',
      tenMau: 'Ví dụ: Báo lỗi luồng giá vàng',
      suKien: 'Sự kiện',
      chuaCoBoGui: '{{ten}} (chưa có bộ gửi tự động)',
      phamVi: 'Phạm vi',
      workflow: 'Workflow được gửi',
      workflowGoiY: 'Để trống là mọi Workflow trong phạm vi.',
      chonWorkflow: 'Mọi Workflow',
      workflowRong: 'Không có Workflow nào trong phạm vi',
      workflowDaMat: 'Không còn trên OpenCore',
      thieuQuyenProject: 'Cần quyền {{quyen}} để chọn Project và Workflow.',
      kenh: 'Kênh gửi',
      kenhBatBuoc: 'Chọn ít nhất một kênh gửi.',
      batBuoc: 'Bắt buộc nhập.',
      daCauHinh: 'Đã có tài khoản gửi',
      chuaCauHinh: 'Chưa có tài khoản gửi',
      guiThu: 'Gửi tin thử',
      dangGuiThu: 'Đang gửi...',
      daGuiThu: 'Đã gửi tin thử qua {{kenh}}.',
      taiKhoan: 'Tài khoản gửi',
      taiKhoanMacDinh: 'Mặc định ({{ten}})',
      bat: 'Bật cấu hình này',
      them: 'Thêm cấu hình',
      luu: 'Lưu cấu hình',
      daTao: 'Đã thêm cấu hình thông báo.',
      daLuu: 'Đã lưu cấu hình thông báo.',
    },
  },
  rpaTaiKhoanGui: {
    maHoaKieu: { starttls: 'STARTTLS (port 587)', ssl: 'SSL/TLS (port 465)', none: 'Không mã hoá' },
    moTa:
      'Tài khoản máy chủ RPA dùng để gửi thông báo lỗi và kết quả luồng chạy. Cấu hình thông báo dùng tài khoản mặc định của từng loại, hoặc tài khoản chọn riêng.',
    them: 'Thêm tài khoản',
    tim: 'Tìm tên tài khoản hoặc email...',
    locLoai: 'Lọc theo loại',
    moiLoai: 'Mọi loại',
    dem: '{{hien}} / {{tong}} tài khoản',
    tongTrang: '{{tu}}–{{den}} / {{tong}} tài khoản',
    rong: 'Chưa có tài khoản gửi nào',
    rongMoTa: 'Thêm tài khoản Gmail SMTP để gửi thông báo qua email, hoặc Telegram Bot để gửi qua Telegram.',
    rongLoc: 'Không có tài khoản nào khớp bộ lọc',
    cotTen: 'Tên tài khoản',
    cotLoai: 'Loại',
    cotGuiTu: 'Gửi từ',
    cotMacDinh: 'Mặc định',
    cotBat: 'Bật',
    capNhat: 'Cập nhật {{luc}}',
    moiWorkflow: 'Gửi cho mọi Workflow',
    gioiHanWorkflow: 'Chỉ gửi cho {{so}} Workflow',
    botDaLuu: 'Đã lưu Bot token',
    botChuaCo: 'Chưa có Bot token',
    datMacDinh: 'Đặt “{{ten}}” làm mặc định',
    laMacDinh: 'Tài khoản mặc định',
    batTaiKhoan: 'Bật tài khoản {{ten}}',
    daDatMacDinh: 'Đã đặt “{{ten}}” làm mặc định.',
    daBat: 'Đã bật tài khoản gửi.',
    daTat: 'Đã tắt tài khoản gửi.',
    sua: 'Sửa tài khoản',
    xoa: 'Xoá tài khoản',
    xoaTieuDe: 'Xoá tài khoản gửi “{{ten}}”?',
    xoaThan:
      'Cấu hình thông báo đang chọn riêng tài khoản này sẽ chuyển sang dùng tài khoản mặc định. Thao tác không hoàn tác được.',
    daXoa: 'Đã xoá tài khoản gửi.',
    chanTrang: 'Mật khẩu ứng dụng và Bot token lưu ở kho bí mật của máy chủ, không hiện lại sau khi lưu.',
    loai: 'Loại tài khoản',
    loaiKhoa: 'Không đổi được loại của tài khoản đã tạo; cần loại khác thì tạo tài khoản mới.',
    gmail: 'Gmail SMTP',
    gmailMoTa: 'Gửi email qua Gmail',
    telegram: 'Telegram Bot',
    telegramMoTa: 'Gửi tin qua bot Telegram',
    form: {
      taoTieuDe: 'Thêm tài khoản gửi',
      suaTieuDe: 'Sửa tài khoản “{{ten}}”',
      ten: 'Tên tài khoản',
      tenMau: 'Email hệ thống Native',
      email: 'Email gửi',
      emailMau: 'noreply@congty.vn',
      appPassword: 'App Password',
      appPasswordGoiY: 'Tạo tại Google Account > Bảo mật > Mật khẩu ứng dụng (cần bật xác minh 2 bước).',
      giuBiMat: 'Để trống nếu không đổi.',
      smtpHost: 'SMTP host',
      smtpPort: 'Port',
      maHoa: 'Mã hoá',
        botToken: 'Bot token',
      botTokenGoiY: 'Lấy từ @BotFather trên Telegram.',
      guiThuToiMail: 'Gửi thử tới',
      guiThuToiMailGoiY: 'Để trống thì gửi tới chính email gửi.',
      guiThuToiTelegram: 'Chat ID nhận tin thử',
      guiThuToiTelegramGoiY: 'Bắt buộc khi gửi tin thử.',
      workflow: 'Workflow được phép gửi',
      workflowGoiY:
        'Để trống là mọi Workflow. Đã chọn thì chỉ lượt chạy của các Workflow này được gửi qua tài khoản, kể cả khi Robot tự chọn kênh.',
      macDinh: 'Đặt làm mặc định',
      macDinhGoiY: 'Cấu hình thông báo không chọn riêng tài khoản sẽ gửi qua tài khoản này.',
      macDinhPhaiBat: 'Tài khoản mặc định phải đang bật.',
      bat: 'Bật tài khoản',
      batGoiY: 'Tài khoản tắt không được dùng để gửi.',
      guiMailThu: 'Gửi mail thử',
      guiTinThu: 'Gửi tin thử',
      dangGuiThu: 'Đang gửi...',
      daGuiMailThu: 'Đã gửi mail thử tới {{toi}}.',
      daGuiTinThu: 'Đã gửi tin thử.',
      canChatId: 'Nhập Chat ID nhận tin thử.',
      them: 'Thêm tài khoản',
      luu: 'Lưu tài khoản',
      daThem: 'Đã thêm tài khoản gửi.',
      daLuu: 'Đã lưu tài khoản gửi.',
      batBuoc: 'Bắt buộc nhập.',
      emailSai: 'Email gửi không hợp lệ.',
      hostSai: 'SMTP host chỉ gồm chữ, số, dấu chấm và gạch ngang.',
      portSai: 'Port phải là số từ 1 đến 65535.',
      tokenSai: 'Bot token không đúng định dạng (dạng 123456:ABC…).',
    },
  },
} as const;
